import { jsx } from 'react/jsx-runtime';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-tabs.css';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
const EGDSTabHighlighter = props => {
  const {
    className,
    style
  } = props;
  return jsx("li", {
    "aria-hidden": "true",
    className: getClassNameList('uitk-tab-highlighter', className),
    style: style
  });
};
EGDSTabHighlighter.displayName = 'EGDSTabHighlighter';
export { EGDSTabHighlighter };